import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { connect } from 'react-redux';

import ListView from '#rscv/List/ListView';

import Header from '#components/view/Header';
import { routeSettings, hasNavbar, NavbarRoute } from '#constants';
import { User } from '#store/atom/user/types';
import { AppState } from '#store/types';
import { authUserSelector } from '#selectors';

import { serverURL } from '#request';

import MenuItem from './MenuItem';

import styles from './styles.scss';

const pages = routeSettings.filter(hasNavbar);

interface OwnProps {
    className?: string;
}
interface PropsFromState {
    user?: User;
}

type Props = PropsFromState & OwnProps;

const mapStateToProps = (state: AppState): PropsFromState => ({
    user: authUserSelector(state),
});

class Navbar extends React.PureComponent<Props> {
    private static menuKeySelector = (data: NavbarRoute) => data.name;

    private static menuRendererParams = (key: string, data: NavbarRoute) => ({
        title: data.title,
        link: data.path,
        disabled: data.disabled,
    });

    public render() {
        const {
            className: classNameFromProps,
            user,
        } = this.props;

        const className = _cs(
            classNameFromProps,
            styles.navbar,
        );

        const filteredPages = pages.filter(
            page => !page.visibleForSupervisor || (user && user.isSupervisor),
        );

        return (
            <nav className={className}>
                <div className={styles.headerContainer}>
                    <Header className={styles.header} />
                    { user && (
                        <div className={styles.userDetails}>
                            <div className={styles.name}>
                                {user.name}
                            </div>
                            <div>
                                {user.email}
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.menu}>
                    <ListView
                        data={filteredPages}
                        keySelector={Navbar.menuKeySelector}
                        renderer={MenuItem}
                        rendererParams={Navbar.menuRendererParams}
                        className={styles.menuItems}
                    />
                    <MenuItem
                        className={styles.logoutButton}
                        title="Logout"
                        link={`${serverURL}/logout/`}
                    />
                </div>
            </nav>
        );
    }
}

export default connect(mapStateToProps)(Navbar);
